import api from '@pray/shared/utils/api';

export async function updateDonationFund({
  artistId = undefined,
  fundId = undefined,
  name = undefined,
  description = undefined,
  imageUrl = undefined,
  isEnabled = undefined,
  defaultAmountMonthly = undefined,
  defaultAmountYearly = undefined,
  amountMonthly2 = undefined,
  amountYearly2 = undefined,
  includeInAppPromotions = undefined,
  causeFeedItemEnabled = undefined,
  causeFeedItemPlacement = undefined,
  causeFeedItemMediaUrl = undefined,
  causeFeedItemMediaType = undefined,
  causeFeedItemAudioUrl = undefined,
  causeFeedItemTargetEnabled = undefined,
  causeFeedItemTargetAmount = undefined,
  causeFeedItemStartsAt = undefined,
  causeFeedItemEndsAt = undefined,
  causeFeedItemOverrideEnabled = undefined,
  causeFeedItemTitle = undefined,
  causeFeedItemDescription = undefined,
  causeFeedItemVideoThumbnailUrl = undefined,
}) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!fundId) throw new Error('Fund ID is required');

  const data = {
    name,
    description,
  };

  if (isEnabled !== undefined) data.is_enabled = isEnabled;
  if (imageUrl !== undefined) data.image_url = imageUrl;
  if (defaultAmountMonthly !== undefined) data.default_amount_monthly = defaultAmountMonthly;
  if (defaultAmountYearly !== undefined) data.default_amount_yearly = defaultAmountYearly;
  if (amountMonthly2 !== undefined) data.amount_monthly_2 = amountMonthly2;
  if (amountYearly2 !== undefined) data.amount_yearly_2 = amountYearly2;
  if (includeInAppPromotions !== undefined) data.include_in_app_promotions = includeInAppPromotions;
  if (causeFeedItemEnabled !== undefined) data.cause_feed_item_enabled = causeFeedItemEnabled;
  if (causeFeedItemPlacement !== undefined) data.cause_feed_item_placement = causeFeedItemPlacement;
  if (causeFeedItemMediaUrl) data.cause_feed_item_media_url = causeFeedItemMediaUrl;
  if (causeFeedItemMediaType !== undefined) data.cause_feed_item_media_type = causeFeedItemMediaType;
  if (causeFeedItemAudioUrl) data.cause_feed_item_audio_url = causeFeedItemAudioUrl;
  if (causeFeedItemTargetEnabled !== undefined) data.cause_feed_item_target_enabled = causeFeedItemTargetEnabled;
  if (causeFeedItemTargetAmount !== undefined) data.cause_feed_item_target_amount = causeFeedItemTargetAmount;
  if (causeFeedItemStartsAt !== undefined) data.cause_feed_item_starts_at = causeFeedItemStartsAt;
  if (causeFeedItemEndsAt !== undefined) data.cause_feed_item_ends_at = causeFeedItemEndsAt;
  if (causeFeedItemOverrideEnabled !== undefined) data.cause_feed_item_override_enabled = causeFeedItemOverrideEnabled;
  if (causeFeedItemTitle !== undefined) data.cause_feed_item_title = causeFeedItemTitle;
  if (causeFeedItemDescription !== undefined) data.cause_feed_item_description = causeFeedItemDescription;
  if (causeFeedItemVideoThumbnailUrl !== undefined) {
    data.cause_feed_item_video_thumbnail_url = causeFeedItemVideoThumbnailUrl || null;
  }

  const url = `/web/studio/artists/${artistId}/funds/${fundId}`;
  const response = await api.executePutRequest(url, data);

  return response.data;
}
